var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoundation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#59BCEE",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5187C6",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.511 43.063l-1.028-3.914H26.7l-1.057 3.914h-6.198l6.812-20.967h7.527l6.898 20.966h-6.17zm-2.199-8.541H27.87c.867-3.276 1.426-5.47 1.678-6.584.253-1.114.422-1.914.507-2.4.096.524.293 1.39.593 2.6.3 1.209.555 2.194.764 2.956l.9 3.428zm11.898-4.37h-3.542V27.6h3.542v-3.495h2.561V27.6h3.542v2.551h-3.542v3.438H44.21V30.15z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundation);
export default __webpack_public_path__ + "static/media/foundation.91d94823bb56dffc53ea720eaa251267.svg";
export { ForwardRef as ReactComponent };